export default __webpack_public_path__ + "static/quick-actions-designs-be793f2ebfcfb05d73b3da1f5eda6c04.png";